import { render, staticRenderFns } from "./JdsConfirmation.vue?vue&type=template&id=873615ce&scoped=true&"
import script from "./JdsConfirmation.vue?vue&type=script&lang=ts&"
export * from "./JdsConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./JdsConfirmation.vue?vue&type=style&index=0&id=873615ce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873615ce",
  null
  
)

export default component.exports